
import { Component, Vue, Prop } from 'vue-property-decorator'
import { postFetch } from '@/service/common'
import { State } from 'vuex-class'

@Component({})
export default class StepOtherOne extends Vue {
  @Prop({ required: true }) data!: any
  @State userInfo!: any
  @State bidType!: any

  timeNumber = 0
  showTimer = false
  timer: any = null
  authLoading = false
  sendLoading = false
  rules: object = {
    person_name: [
      {
        required: true,
        message: '请输入法定代表人姓名',
      },
    ],
    person_card_type: [
      {
        required: true,
        message: '请选择法定代表人证件类型',
      },
    ],
    person_idcard: [
      {
        required: true,
        message: '请输入法定代表人证件号码',
      },
    ],
    sms_code: [
      {
        required: true,
        message: '请输入短信验证码',
        trigger: 'change',
      },
    ],
  }

  get cardType() {
    const base: any = {
      '1': '中国居民身份证',
      '2': '护照',
      '3': '港澳居民来往内地通行证（回乡证）',
      '4': '台湾居民来往大陆通行证（台胞证）',
    }
    if (this.bidType === 6) delete base[1]
    return base
  }

  beforeDestroy() {
    clearInterval(this.timer)
  }

  handleSubmit() {
    const vm: any = this.$refs.ruleForm
    vm.validate((valid: any) => {
      if (valid) {
        this.vertifyMessage()
      } else {
        return false
      }
    })
  }

  async vertifyMessage() {
    this.authLoading = true
    const { code, msg }: any = await postFetch('vertifyUpgradeSmsCode', {
      sms_code: this.data.sms_code,
    })
    if (code === 0) {
      this.$emit('forward')
    } else {
      this.$message.error(msg)
    }
    this.authLoading = false
  }
  async sendMessage() {
    this.sendLoading = true
    const { code, msg }: any = await postFetch('sendUpgradeSmsCode', this.data)
    if (code === 0) {
      this.$message.success('平安银行已发送短信验证码，请注意查收')
      this.timeNumber = 120
      this.showTimer = true
      this.timer = setInterval(() => {
        if (this.timeNumber > 0) {
          this.timeNumber--
        } else {
          clearInterval(this.timer)
          this.showTimer = false
        }
      }, 1000)
    } else {
      this.$message.error(msg)
    }
    this.sendLoading = false
  }
}
